"use client";

import React, { useEffect, useState, useRef } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
const EngineParticleSketch = () => {
  const parentRef = useRef<HTMLDivElement>(null);
  const [particles, setParticles] = useState<Array<{
    id: number;
    left: string;
    delay: string;
    duration: string;
    color: string;
  }>>([]);
  useEffect(() => {
    const newParticles = Array.from({
      length: 150
    }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      delay: `${Math.random() * 2}s`,
      duration: `${3 + Math.random() * 4}s`,
      color: i % 2 === 0 ? 'bg-yellow-600' : 'bg-cyan-300'
    }));
    setParticles(newParticles);
  }, []);
  return <div data-section-id="3843" ref={parentRef} className="w-full h-full min-h-[400px] relative overflow-hidden">
      {}
      {particles.map(particle => <div key={particle.id} className={`absolute ${particle.color} animate-pulse`} style={{
      left: particle.left,
      top: '100%',
      width: '3px',
      height: '8px',
      animation: `float ${particle.duration} linear ${particle.delay} infinite`,
      opacity: 0.6
    }} />)}
      
      <style>{`
        @keyframes float {
          0% {
            transform: translateY(0);
            opacity: 0;
          }
          10% {
            opacity: 0.6;
          }
          90% {
            opacity: 0.6;
          }
          100% {
            transform: translateY(-${window.innerHeight || 800}px);
            opacity: 0;
          }
        }
      `}</style>
    </div>;
};
export default function TheFoundersEdge() {
  return <section id="redefining-wealth-creation" className="dark bg-background text-foreground relative w-full min-h-screen flex items-center overflow-hidden py-20">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <span className="text-[20vw] font-black text-foreground opacity-[0.03] tracking-widest whitespace-nowrap font-serif">
          CRAFTED
        </span>
      </div>

      <div className="container mx-auto px-4 relative z-10 h-full">
        <div className="flex flex-col lg:flex-row items-center h-full gap-12 lg:gap-0">
          
          {}
          <div className="w-full lg:w-[60%] flex flex-col justify-center space-y-8 lg:pr-12">
            <h2 className="text-6xl sm:text-8xl md:text-9xl lg:text-[110px] font-serif font-bold tracking-tighter leading-[0.9] uppercase">
              <span className="block text-foreground drop-shadow-sm">Wealth Isn't Found.</span>
              <span className="block bg-clip-text text-transparent bg-gradient-to-r from-primary via-slate-300 to-primary animate-pulse duration-[4000ms]">
                It's Crafted.
              </span>
            </h2>
            
            <div className="pt-4">
              <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground border border-primary/20 rounded-none px-10 py-8 text-xl font-bold tracking-wider shadow-2xl transition-all hover:scale-105 hover:shadow-primary/20">
                <Link to="/ContactPage">
                  CRAFT YOUR FUTURE
                  <ArrowRight className="ml-2 h-6 w-6" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="w-full lg:w-[40%] h-[500px] lg:h-[800px] flex items-center justify-center relative">
            {}
            <div className="w-full h-full border border-border/20 bg-card/10 backdrop-blur-md relative overflow-hidden rounded-sm shadow-2xl">
                {}
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-40"></div>
                <div className="absolute bottom-0 right-0 w-20 h-20 border-r-2 border-b-2 border-primary/20 rounded-br-xl"></div>
                
                {}
                <EngineParticleSketch />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent pointer-events-none"></div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}